import { NgModule } from "../../../node_modules/@angular/core";
import { CommonModule } from "../../../node_modules/@angular/common";
import { HttpClientModule } from "../../../node_modules/@angular/common/http";
import { CoreModule } from "../core/core.module";
import { VendorModule } from "../core/vendor.module";
import { SharedComponentsModule } from "../shared-components/shared-components.module";
import { SharedServicesModule } from "../shared-services/shared-services.module";
import { SecurityModule } from "../security/security.module";
import { SlideshowModule } from "../../../node_modules/ng-simple-slideshow";
import { QuillEditorModule } from "../../../node_modules/ngx-quill-editor";
import { NgxMaskModule } from "../../../node_modules/ngx-mask/build/ngx-mask.module";
import { BannerComponent } from "./banner.component";
import { SecurityService } from "../security/security.service";
import { LoguedGuardService } from "../security/logued-guard.service";
import { BannerlistComponent } from "./bannerlist/bannerlist.component";
import { BannerAddComponent } from "./banner-add/banner-add.component";
import { BannerResolver } from "./banner.resolver";
import { BannerImagenUploadComponent } from "./banner-imagen-upload/banner-imagen-upload.component";
import { BannerCarouselComponent } from "./banner-carousel/banner-carousel.component";


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CoreModule,
    VendorModule,
    SharedComponentsModule,
    SharedServicesModule,
    SecurityModule,
    SlideshowModule,
    QuillEditorModule,
    NgxMaskModule,
  ],
  declarations: [
    BannerComponent,
    BannerlistComponent,
    BannerAddComponent,
    BannerImagenUploadComponent,
    BannerCarouselComponent
  ],
  exports: [
    BannerComponent,
    BannerlistComponent,
    BannerAddComponent,
    BannerImagenUploadComponent,
    BannerCarouselComponent
  ],
  providers: [
    SecurityService,
    LoguedGuardService,
    BannerResolver
  ]
})
export class BannerModule { }



// WEBPACK FOOTER //
// ./src/app/banner/banner.module.ts